import type { FC, ReactElement } from 'react';
import React from 'react';
import cn from 'classnames';
import { cloneWidget } from '@alfa-bank/site-util-create-widget/clone-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { getVersionOfPortal } from '../../helpers/get-version-of-portal';

import type { TCommonProps } from './models';

export const Switcher: FC<TCommonProps> = ({
    children,
    collectorData,
    possibleAlternativeVersions = ['r'],
    styles,
}) => {
    const activeLinkType =
        getVersionOfPortal(possibleAlternativeVersions, collectorData?.url) || '';

    const isActiveLinkType = (child: ReactElement) => activeLinkType === child.props.linkType;

    return (
        <div className={cn(styles.external, styles.smeSwitcher)}>
            {children.map((child, index) => {
                const isActive = isActiveLinkType(child);
                const view = isActive ? 'accent-primary-small' : 'primary-small';
                const theme = isActive ? 'blue' : 'white';
                const kind = isActive ? 'common' : 'caption';

                return (
                    <Text
                        key={`link-type-${index}`}
                        className={cn(
                            styles.external,
                            {
                                [styles.activeLinkType]: isActiveLinkType(child),
                            },
                            styles.linkWrapper
                        )}
                        styler={{ margin: 0 }}
                        tag="div"
                        view={view}
                    >
                        {cloneWidget(child, {
                            theme,
                            kind,
                        })}
                    </Text>
                );
            })}
        </div>
    );
};
